import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Modal, ModalBody } from 'reactstrap';
import PropTypes from 'prop-types';

import Button from 'components/App/Button';

import { ReactComponent as CheckedMarkSuccess } from 'assets/images/location/checked_mark_success-svg.svg';
import images from 'assets/images';

import { useLockedBody } from 'hooks/useLockedBody';
import styles from './ModalSuccess.module.scss';

const cx = classNames.bind(styles);

function ModalSuccess(props) {
  const {
    isOpen,

    message,

    onCloseModal,
  } = props;

  useLockedBody(isOpen);

  return (
    <div className={styles.Component}>
      <Modal
        fade
        size="md"
        isOpen={isOpen}
        onClosed={onCloseModal}
        toggle={onCloseModal}
        className={styles.Modal}
      >
        <ModalBody className={styles.ModalBody}>
          <Button
            isDefault
            classes={cx('Button__Close')}
            onClick={onCloseModal}
          >
            <img
              src={images.modalClose.default}
              alt=""
              className="img-fluid img-close"
            />
          </Button>

          <CheckedMarkSuccess className="mb-24 Checkmark" />

          <div className="Content">{message}</div>
        </ModalBody>
      </Modal>
    </div>
  );
}

ModalSuccess.propTypes = {
  isOpen: PropTypes.bool.isRequired,

  message: PropTypes.string.isRequired,

  onCloseModal: PropTypes.func.isRequired,
};

ModalSuccess.defaultProps = {};

export default memo(ModalSuccess);
